export default "__VITE_ASSET__C90hChxx__"